export const GET_APPLE2FA = "GET_APPLE2FA";
export const GET_APPLE2FA_SUCCESS = "GET_APPLE2FA_SUCCESS";
export const GET_APPLE2FA_FAIL = "GET_APPLE2FA_FAIL";

export const ADD_APPLE2FA_SUCCESS = "ADD_APPLE2FA_SUCCESS";
export const ADD_APPLE2FA_FAIL = "ADD_APPLE2FA_FAIL";
export const UPDATE_APPLE2FA_SUCCESS = "UPDATE_APPLE2FA_SUCCESS";
export const DELETE_APPLE2FA_SUCCESS = "DELETE_APPLE2FA_SUCCESS";
